import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { BillingSlice, BillingOverview } from './CoporateBillingTypes'
import { useAppSelector } from '../storeExports'
import { API } from 'aws-amplify'
import { Logger } from '@meprism/app-utils'

export const billingInitialState: BillingSlice = {
  overview: undefined as any,
}

const getBillingOverviewApi = (): Promise<any> => {
  return API.get('Corporate', '/billing/overview', {}) 
}

export const getBillingOverview = createAsyncThunk(
  'billing/getBillingOverview',
  async () => {
    try {
      const response = await getBillingOverviewApi()
      return response.overview as BillingOverview
    } catch (error) {
      Logger.error(`Error fetching billing overview: ${error}`)
      throw error
    }
  }
)

const { reducer } = createSlice({
  name: 'billing',
  initialState: billingInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBillingOverview.fulfilled, (state, action) => {
      state.overview = action.payload
    })
  },
})

export const CorporateBillingReducer = reducer

export const CorporateBillingSelector = () =>
  useAppSelector((state) => state.corporateBilling.overview)